import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["iconRender", "visibilityToggle", "className", "disabled", "onClear"];
import * as React from 'react';
import { composeRef } from "rc-util/es/ref";
import InputBase, { INPUT_PREFIX_CLS } from './InputBase';
import { ConfigContext, SizeContext, LocaleContext } from '../ConfigProvider';
import Eye from '@bedrock/icons-react/Eye';
import EyeSlash from '@bedrock/icons-react/EyeSlash';

var RefPassword = function RefPassword(props, ref) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrettyCls = _React$useContext.getPrettyCls,
      getLocale = _React$useContext.getLocale;

  var contextLocale = React.useContext(LocaleContext);
  var contextSize = React.useContext(SizeContext);

  var iconRender = props.iconRender,
      _props$visibilityTogg = props.visibilityToggle,
      visibilityToggle = _props$visibilityTogg === void 0 ? true : _props$visibilityTogg,
      className = props.className,
      disabled = props.disabled,
      onClear = props.onClear,
      restProps = _objectWithoutProperties(props, _excluded);

  var prefixCls = restProps.prefixCls;

  var _React$useState = React.useState('password'),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      type = _React$useState2[0],
      setType = _React$useState2[1];

  var inputRef = React.useRef(null);
  var composedInputRef = composeRef(ref, inputRef);
  var placeholder = getLocale(contextLocale, 'Input').passwordPlaceholder;
  var handleChangeType = React.useCallback(function () {
    var _inputRef$current, _inputRef$current$inp;

    if (disabled) {
      return;
    }

    if (type === 'text') {
      setType('password');
    } else {
      setType('text');
    }

    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$inp = _inputRef$current.input) === null || _inputRef$current$inp === void 0 ? void 0 : _inputRef$current$inp.focus();
    setTimeout(function () {
      var _inputRef$current2, _inputRef$current2$in;

      inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : (_inputRef$current2$in = _inputRef$current2.input) === null || _inputRef$current2$in === void 0 ? void 0 : _inputRef$current2$in.setSelectionRange(-1, -1);
    }, 1);
  }, [type, disabled]);

  var handleClear = function handleClear(e) {
    var _inputRef$current3, _inputRef$current3$in;

    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : (_inputRef$current3$in = _inputRef$current3.input) === null || _inputRef$current3$in === void 0 ? void 0 : _inputRef$current3$in.focus();
    typeof onClear === 'function' && onClear(e);
  };

  var suffixNode = React.useMemo(function () {
    if (!visibilityToggle) {
      return null;
    }

    var ICON = type === 'text' ? Eye : EyeSlash;
    return /*#__PURE__*/React.createElement("span", {
      key: "password_suffix",
      onClick: handleChangeType
    }, typeof iconRender === 'function' ? iconRender(type === 'text') : /*#__PURE__*/React.createElement(ICON, {
      className: getPrettyCls("".concat(INPUT_PREFIX_CLS, "-suffix-password-toggle-icon"), prefixCls)()
    }));
  }, [visibilityToggle, type, iconRender, getPrettyCls, prefixCls, handleChangeType]);
  return /*#__PURE__*/React.createElement(InputBase, _objectSpread({
    ref: composedInputRef,
    className: getPrettyCls("".concat(INPUT_PREFIX_CLS, "-password-wrapper"), prefixCls, className)(),
    getPrettyCls: getPrettyCls,
    type: type,
    suffix: suffixNode,
    disabled: disabled,
    onClear: handleClear,
    size: contextSize,
    placeholder: placeholder
  }, restProps));
};

var Password = /*#__PURE__*/React.forwardRef(RefPassword);
Password.defaultProps = {
  visibilityToggle: true
};
export default Password;